<script>
  import DashboardTitle from "../../../../components/dashboard/DashboardTitle.svelte";
  import TaskWidgetContainer from "./TaskWidgetContainer.svelte";
  import DashboardWidgetTitle from "../../../../components/dashboard/DashboardWidgetTitle.svelte";
  import DialogSpanCalendarPicker from "../../../../components/DialogSpanCalendarPicker.svelte";
  import DialogExpandSpan from "../../../../components/DialogExpandSpan.svelte";

  export let boxTitle = null;
  export let taskList;
  export let onChange;

  let widget = null;
  let widgetParent = null;
  let showWidget = false;

  let currentTask = { name: "", end: "", notes: "" };

  let openWidget = (show) => {
    showWidget = show;
    if (showWidget) {
      window.$("body").append(widget);
    } /* else {
      widgetParent.append(widget);
    } */
  };
</script>

<div class="dashboardContainer">
  <DashboardTitle title={boxTitle} numEvents={taskList.length} />
  <div class="dashboardBody">
    <div class="messages customScrollbars">
      {#each taskList as task}
        <!-- svelte-ignore missing-declaration -->
        <TaskWidgetContainer
          {task}
          onOpen={() => {
            currentTask.name = task.name;
            currentTask.end = task.end
              ? moment(task.end, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")
              : "";
            currentTask.notes = task.notes;
            currentTask = currentTask;
            openWidget(true);
          }}
          {onChange}
        />
      {/each}
    </div>
  </div>
  <div
    bind:this={widget}
    class="widgetInfo"
    style={showWidget ? "" : "display: none"}
  >
    <div class="widgetContainer">
      <DashboardWidgetTitle
        title={currentTask.name}
        onClose={() => {
          showWidget = false;
          openWidget(false);
        }}
      />
      <div class="widgetBody">
        <div class="widgetData">
          <!-- svelte-ignore missing-declaration -->
          <div class="taskEndDate">
            {#if currentTask.end}
              <label for="description">End</label>
              <DialogSpanCalendarPicker
                bind:text={currentTask.end}
                calendarOptions={[]}
                action={"show"}
                last={false}
              />
            {/if}
          </div>
          <div class="taskNotes">
            <div class="descriptionArea customScrollbars">
              <label for="description">Notes</label>

              <DialogExpandSpan
                bind:text={currentTask.notes}
                action={"show"}
                last={true}
                noScrolls={true}
                height="81px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  div.dashboardContainer {
    width: 100%;
    height: 100%;
  }

  div.messages {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
  }

  div.dashboardBody {
    width: 100%;
    height: 85%;
    padding: 5% 0 5% 5%;
  }

  div.widgetInfo {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    background-color: var(--labit-background-gray-trans);
    z-index: 10002;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  div.widgetContainer {
    background-color: white;
    width: 650px;
    border-radius: 14px;
    max-height: 400px;
  }

  div.widgetBody {
    padding: 10px;
    max-height: 400px;
  }

  div.widgetData {
    display: flex;
    flex-direction: column;
  }

  label {
    font-size: 12px;
    color: var(--labit-card-gray);
  }

  div.taskEndDate {
    margin-bottom: 8px;
  }

  div.descriptionArea {
    display: flex;
    flex-direction: column;
    overflow: scroll;
    max-height: 310px;
  }
</style>
